import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import { RegistrationControllerService } from "../../../services/registration-controller/registration-controller.service";
import { DeterminantControllerService } from "../../../services/registration-controller/determinant-controller.service";
import { Store } from "../../../services/store.service";
import { ModalService } from "../../utils/base_modal.component";
import { TranslatedBaseError } from "../TranslatedBaseError";
import {TranslateService } from "@ngx-translate/core";
import { FieldGroup } from "../../../models/field-group";
import { FormField } from "../../../models/form-field";
import { ServiceField } from "../../../models/service-field";
import { DataMappingHelpers } from "../../../models/data-mapping-helpers";
import * as _ from "lodash";
import { map } from 'rxjs/operators';

@Component({
  selector: "fields-table",
  templateUrl: "./fields-table.component.html",
  providers: [FormControllerService, ModalService, ToastrService, RegistrationControllerService, DeterminantControllerService],
  encapsulation: ViewEncapsulation.None,
})
export class FieldsTableComponent extends TranslatedBaseError implements OnInit {
  public serviceId: string;
  public baseUrl: string;
  public allFields: any[] = [];
  public allRegistrations: any[] = [];
  public allDeterminants: any[] = [];
  public selectedRegistrations: any[] = [];
  public selectedDeterminants: any[] = [];

  public fields: any[] = [];
  public searchFields: string = "";
  public searchStringFormatted: string = "";

  public loadingFields: boolean = true;

  public selectedField: any = null;
  public selectedDetails: any = null;

  public showDetails: boolean = false;

  constructor(private route: ActivatedRoute,
              private formControllerService: FormControllerService,
              private registrationControllerService: RegistrationControllerService,
              private determinantControllerService: DeterminantControllerService,
              public store: Store,
              public toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/fieldstable";
    });
    this.getDatas(this.serviceId);
  }

  public getDatas(serviceId: string) {
    const components = [];
    const promises = [];
    promises.push(
      this.formControllerService.getFilteredFormFields(serviceId, null, false, true, true, false, true, false, true).pipe(map((data) => {
        return data;
      })).toPromise(),
    );
    promises.push(
      this.registrationControllerService.getRegistrationsList(serviceId).pipe(map((data) => {
        return data;
      })).toPromise(),
    );
    promises.push(
      this.determinantControllerService.getServiceDeterminants(serviceId).pipe(map((data) => {
        return data;
      })).toPromise(),
    );

    Promise.all<any[]>(promises).then((results: any[]) => {
      console.log(results);
      this.allDeterminants = results[2];
      this.reloadFormArray(results[0].sort((a, b) => a.orderNumber - b.orderNumber ));
      this.allRegistrations = results[1];
    });
  }

  public getRegistration(id) {
    return this.allRegistrations.find((r) => {
      return r.id === id;
    }).name;
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
  }

  public closeDrawer(e) {
    if (e) {
      this.selectedField = null;
      this.selectedDetails = null;
      this.showDetails = false;
    }
  }

  public showSelectedDetails(e) {
    this.selectedField = e.item;
    this.selectedDetails = e.detail;
    this.showDetails = true;
    console.log(this.selectedField, this.selectedDetails);
  }

  public reloadFormArray(forms: ServiceField[]): void {
    this.allFields = [];
    this.addItems(forms, null);
    forms.forEach((field) => {
        let fieldGroup = null;
        fieldGroup = new FieldGroup();
        fieldGroup.level = 1;
        this.parseChildren(field, fieldGroup, field.form, 0);
        fieldGroup.items = field.items;
        fieldGroup.groupName = field.form;
        fieldGroup.name = field.form;
        fieldGroup.orderNumber = field.orderNumber;
        this.allFields.push(fieldGroup);
    });
    this.buildTree();
  }

  private addItems(components: any[], formName: string) {
    components.forEach((field) => {
      if (field.fullKey) {
        field.key = field.fullKey;
      }
      if (field.formType) {
        formName = field.formType;
      }
      field.form = formName;
      if (field.components) {
        field.leaf = false;
        field.items = field.components;
        this.addItems(field.items, formName);
      } else {
        field.leaf = true;
      }
    });
  }

  public parseChildren(field: any, fieldGroup: any, fieldGroupName: string, lvl: number) {
    const formField = this.createFormField(field, lvl ? Number(lvl) + 1 : 1);
    formField.formTitle = fieldGroupName;
    fieldGroup.fields.push(formField);
    field.isgroup = !field.leaf;
    field.usedInDeterminants = this.allDeterminants.filter((det) => {
      console.log(field.key, det.targetFormFieldKey, det.sourceFormFieldKey, det.targetFormFieldJsonPath?.includes(det.key));
      return (field.key === det.targetFormFieldKey) || (field.key === det.sourceFormFieldKey) || det.targetFormFieldJsonPath?.includes(det.key);
    });
    field.level = lvl ? Number(lvl) + 1 : 1;
    if (field.isgroup) {
      // TODO: why name is null/undefined?
      if (field.name == null) {
        field.name = "";
      }
      field.name = field.name.replace(" form page", "");
      field.tree = field.name;
    }
    field.fieldName = field.name;
    field.typeclass = DataMappingHelpers.getFieldClass(field.type, field.multiple);
    field.field = formField;
    if (field.items) {
        field.items.forEach((item) => {
            this.parseChildren(item, fieldGroup, fieldGroupName, field.level);
        });
    }
  }

  public createFormField(field: ServiceField, lvl) {
    const formField = new FormField();
    const fieldKey = field.key.replace(/,/g, "-");
    formField.fieldKey = field.key;
    formField.formTitle = field.form;
    formField.type = field.type;
    formField.level = lvl;
    formField.orderNumber = field.orderNumber;
    formField.remoteType = this.setFieldRemoteType(field.type);
    if (field.name && field.name.toLocaleLowerCase() === "catalog") {
        field.name = "Value + internal key";
    }
    if (field.name && field.name.toLocaleLowerCase() === "key") {
        field.name = "Internal key";
        formField.type = "KEY";
        field.type = "KEY";
        // formField.remoteType = "KEY";
    }
    if (field.key && field.key.includes("CATALOG_EXTERNAL_KEY")) {
        formField.type = "KEY";
        field.type = "KEY";
        // formField.remoteType = "KEY";
    }
    if (field && field.name && field.name.startsWith("Role ")) {
        field.name = field.name.slice(4);
    }
    formField.fieldName = field.name;
    formField.label = field.name;
    formField.filter = field.filter;
    if (formField.type === "CLASSIFICATION" || formField.type === "catalog" || formField.type === "KEY") {
        formField.filter = null;
        field.filter = null;
    }
    // Hide content fields - to remove if needed
    if (field.type === "htmlelement") {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.label && formField.label.indexOf("value to key") !== -1) {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.fieldKey && formField.fieldKey.indexOf("VALUE_TO_KEY") !== -1) {
        formField.inputHidden = false;
        formField.outputHidden = false;
    } /* else {
        formField.inputHidden = this.bot.hiddenInputFormFields && JSON.parse(this.bot.hiddenInputFormFields).indexOf(fieldKey) > -1;
        formField.outputHidden = this.bot.hiddenOutputFormFields && JSON.parse(this.bot.hiddenOutputFormFields).indexOf(fieldKey) > -1;
    } */
    return formField;
  }

  public orderGroupItems(group) {
    if (group && group.items && group.items.length) {
        group.items.sort((a, b) => {
            return a.orderNumber < b.orderNumber;
        });
        group.items.forEach((i) => {
            this.orderGroupItems(i);
        });
    }
  }

  public setFieldRemoteType(type: string) {
    if (type) {
        switch (type.toLowerCase()) {
            case "date":
            case "datetime":
            case "date-time":
                return "date";
            case "numeric":
            case "number":
            case "decimal":
            case "integer":
                return "Number";
            case "checkbox":
            // case "selectboxes":
            //     return "checkbox";
            case "boolean":
                return "Boolean";
            case "document":
            case "fileupload":
            case "file":
            case "requirement":
            case "result":
            case "fileupload":
                return "file";
            case "classification":
            case "catalog":
                return "catalog";
            // case "fileupload":
                // return "fileupload";
            case "radio":
                return "radio";
            // case "checkbox":
            case "selectboxes":
            case "text":
            case "string":
            case "textfield":
            case "mycontent":
            default:
                return "string";
        }
    } else {
        return "Text";
    }
  }

  public checkIfGroupExists(items: FieldGroup[], groupName: string): FieldGroup {
    let matchFieldGroup = null;
    if (items) {
        items.some((item) => {
            if (item.isgroup && item.groupName === groupName) {
                matchFieldGroup = item;
                return true;
            }
            matchFieldGroup = this.checkIfGroupExists(item.items, groupName);
            if (matchFieldGroup !== null) {
                return true;
            }
        });
    }
    return matchFieldGroup;
  }

  public getGroups(fields, isgroup): any[] {
    const nodes = [];
    fields.forEach((field) => {
            nodes.push({
                isgroup: isgroup ? isgroup : false,
                leaf: !isgroup ? true : false,
                field,
                typeclass: DataMappingHelpers.getFieldClass(field.type),
                name: field.label,
                title: field.label,
            });
    });
    return nodes;
  }

  public filterRegistration(item) {
      return item.registrations && this.selectedRegistrations.every((reg) => item.registrations.includes(reg));
  }

  public filterRegistrations(items) {
    return items.filter((item) => {
      if (item.isgroup) {
        item.items = this.filterRegistrations(item.items);
        return item.items.length > 0;
      }
      return this.filterRegistration(item);
    });
  }
  public filterDeterminant(item) {
    return item.determinants && this.selectedDeterminants.every((reg) => item.determinants.map((d) => d.id).includes(reg)) ||
      item.usedInDeterminants && this.selectedDeterminants.every((reg) => item.usedInDeterminants.map((d) => d.id).includes(reg));
  }

  public filterDeterminants(items) {
    return items.filter((item) => {
      if (item.isgroup) {
        item.items = this.filterDeterminants(item.items);
        return item.items.length > 0;
      }
      return this.filterDeterminant(item);
    });
  }

  public filterSearchItem(item) {
    return item.label && item.label.toLowerCase().includes(this.searchStringFormatted.toLowerCase());
  }

  public filterSearchArray(items) {
    return items.filter((item) => {
      if (item.isgroup) {
        item.items = this.filterSearchArray(item.items);
        return item.items.length > 0 || this.filterSearchItem(item);
      }
      return this.filterSearchItem(item);
    });
  }

  public filterItems(items) {
    items.forEach((it) => {
        if (this.selectedRegistrations && this.selectedRegistrations.length > 0) {
          it.items = this.filterRegistrations(it.items);
        }
        if (this.selectedDeterminants && this.selectedDeterminants.length > 0) {
          it.items = this.filterDeterminants(it.items);
        }
        if (this.searchStringFormatted) {
          it.items = this.filterSearchArray(it.items);
        }
    });
    return items.filter((it) => {
      return it.items && it.items.length > 0;
    });
  }

  public searchInFields(value: any): void {
    this.searchStringFormatted = value.toLowerCase();
    this.fields = this.filterItems(_.cloneDeep(this.allFields));
    if (!(value && value.length)) {
       this.searchFields = "";
    }
  }

  public searchByRegistrations() {
    this.fields = this.filterItems(_.cloneDeep(this.allFields));
  }

  public searchByDeterminants() {
    this.fields = this.filterItems(_.cloneDeep(this.allFields));
  }

  public buildBranchesAndLeaves(branches: FieldGroup[]) {
      if (branches) {
          branches.forEach((branch) => {
              branch.items = branch.items ? branch.items : (branch.fields && this.getGroups(branch.fields, undefined));
              this.buildBranchesAndLeaves(branch.items);
          });
      }
  }

  public buildTree(): void {
    this.buildBranchesAndLeaves(this.allFields);
    this.fields = _.cloneDeep(this.allFields);
    console.log(this.fields);
    this.loadingFields = false;
  }

}
